import { apiService } from "../../services/ApiService";
import { porterEndpoints, endpoints } from "../../utils/endpoints";
import { DeliveryModes, DispatchMode } from "../../types";

export interface DeliveryStopResponse {
  address: {
    streetAddress1?: string;
    streetAddress2?: string;
    city?: string;
    state?: string;
    pincode?: string;
    country?: string;
    lat?: number;
    lng?: number;
    contactDetails?: {
      name: string;
      phoneNumber: string;
    };
    address?: {
      streetAddress1: string;
      streetAddress2?: string;
      city: string;
      state: string;
      pincode: string;
      country: string;
      lat: number;
      lng: number;
      contactDetails: {
        name: string;
        phoneNumber: string;
      };
    };
  };
  status: "PENDING" | "DELIVERED";
  deliveredAt?: string;
}

export interface ShipmentPayload {
  orderNumbers: string[];
  additionalComments: string;
  deliveryMode?: DeliveryModes;
  dispatchMode?: DispatchMode;
}

export interface ShipmentResponse {
  success: boolean;
  message: string;
  data?: {
    shipmentId: string;
    customerId?: string;
    supplierId: string;
    orderNumbers: string[];
    status: string;
    customerIds?: string[];
    deliveryStops?: Record<string, DeliveryStopResponse>;
    dispatchMode?: DispatchMode;
    pickupDetails: {
      address: {
        streetAddress1: string;
        streetAddress2?: string;
        city: string;
        state: string;
        pincode: string;
        country: string;
        lat: number;
        lng: number;
        contactDetails: {
          name: string;
          phoneNumber: string;
        };
      };
    };
    dropDetails: {
      address?: {
        streetAddress1: string;
        city: string;
        state: string;
        pincode: string;
        country: string;
        lat: number;
        lng: number;
        contactDetails: {
          name: string;
          phoneNumber: string;
        };
      };
      [orderNo: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
  };
  errors?: string[];
}

export const createShipment = async (
  payload: ShipmentPayload,
  skipGeocodeValidation?: boolean,
): Promise<ShipmentResponse> => {
  const query = skipGeocodeValidation ? "?skipGeocodeValidation=true" : "";
  const response = await apiService
    .axiosCruds()
    .post(`${endpoints.createShipment}${query}`, payload);
  return response.data;
};

export const markConsignmentDelivered = async (
  shipmentId: string,
  orderNo: string,
): Promise<any> => {
  const response = await apiService
    .axiosCruds()
    .post(
      `/v1/shipments/${shipmentId}/consignments/${orderNo}/mark-delivered`,
    );
  return response.data;
};

export const bookPorter = async (payload: { shipmentId: string }) => {
  const response = await apiService
    .baseAxiosCruds()
    .post(porterEndpoints.bookPorter, payload);
  return response.data;
};

export const deleteShipment = async (shipmentId: string): Promise<any> => {
  const response = await apiService
    .axiosCruds()
    .delete(endpoints.deleteShipment(shipmentId));
  return response.data;
};
